import { render, staticRenderFns } from "./PorTipo.vue?vue&type=template&id=635d314a&scoped=true&lang=pug&"
import script from "./PorTipo.vue?vue&type=script&lang=js&"
export * from "./PorTipo.vue?vue&type=script&lang=js&"
import style0 from "./PorTipo.vue?vue&type=style&index=0&id=635d314a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635d314a",
  null
  
)

export default component.exports